<!-- Filter by type -->
<mat-chip-listbox class="type-selector" *ngIf="storyTypes.length > 1"
               (change)="filterType = $event.value ? $event.value.toLowerCase() : 'all'" aria-label="select a story type">
  <mat-chip-option [selected]="filterType == 'all'"
            (click)="filterType = 'all'" [selectable]="filterType != 'all'">All</mat-chip-option>
  <mat-chip-option *ngFor="let type of storyTypes"
            [selected]="filterType == type"
            (click)="filterType = type">{{type | capitalizeFirstLetter}}</mat-chip-option>
</mat-chip-listbox>

<!-- Filter by status-->
<mat-chip-listbox class="status-selector" *ngIf="storyStatuses.length > 1"
               (change)="filterStatus = $event.value ? $event.value.toLowerCase() : 'all'" aria-label="select a story status">
  <mat-chip-option [selected]="filterStatus == 'all'"
            (click)="filterStatus = 'all'" [selectable]="filterStatus != 'all'">All</mat-chip-option>
  <mat-chip-option *ngFor="let status of storyStatuses"
            [selected]="filterStatus == status"
            (click)="filterStatus = status">{{status | capitalizeFirstLetter}}</mat-chip-option>
</mat-chip-listbox>

<!-- Filter by tags -->
<mat-form-field>
  <mat-label>Filter by tags</mat-label>
  <mat-chip-grid #chipGrid aria-label="Tag selection">
    <mat-chip-row *ngFor="let tag of filterByTags" (removed)="remove(tag)">
      {{tag}}
      <button matChipRemove [attr.aria-label]="'remove '+tag">
        <mat-icon fontIcon="cancel"></mat-icon></button>
    </mat-chip-row>
  </mat-chip-grid>
  <input placeholder="Search..." #tagInput
         [formControl]="tagControl" [matChipInputFor]="chipGrid"
         [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
         (matChipInputTokenEnd)="add($event)" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">{{tag}}</mat-option>
  </mat-autocomplete>
</mat-form-field>

<!-- Stories -->
<ng-container *ngIf="stories$ | async as _stories; else loadingOrError">
  <ng-container *ngIf="_filterByTags(_stories, filterByTags) | filterStoriesByType:filterType | filterStoriesByStatus:filterStatus as stories">
    <section class="stories">
      <ng-container *ngIf="stories.length > 0; else noStories">
        <article class="story" *ngFor="let story of stories" [routerLink]="[nav_path.stories, story.slug]">
          <em class="story-type">{{story.type | capitalizeFirstLetter}}</em>
          <div class="image-container">
            {{story.title?.charAt(0)}}
            <picture *ngIf="story.image">
              <img class="image" [alt]="story.title" [src]="story.image" />
            </picture>
          </div>
          <div class="details">
            <div class="top">
              <div class="left">
                <h3 class="title">
                  <anon-story-title [type]="story.type" [status]="story?.problemStatus">{{story.title}}</anon-story-title>
                </h3>
                <p class="byline">{{story.byline}}</p>
              </div>
              <div class="right">
                <!--              <button mat-icon-button><mat-icon>star_outline</mat-icon></button>-->
              </div>
            </div>
            <div class="bottom">
              <p class="author">{{story.author?.name}} <ng-container *ngIf="story.readTime">• <em>{{story.readTime}} min read</em></ng-container></p>
              <p class="created">{{story.created.seconds! * 1000 | dateAgo}}</p>
            </div>
          </div>
        </article>
      </ng-container>

      <ng-template #noStories>
        <article class="story" [routerLink]="[nav_path.newStory]">
          <em class="story-type">No Stories</em>
          <div class="image-container">
            <mat-icon>history_edu</mat-icon>
          </div>
          <div class="details">
            <div class="top">
              <div class="left">
                <h3 class="title">No stories yet.</h3>
                <p class="byline">Click here to write a new story.</p>
              </div>
              <div class="right"></div>
            </div>
          </div>
        </article>
      </ng-template>
    </section>
  </ng-container>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
